import _ from 'lodash';
import dynamic from 'next/dynamic';
import Script from 'next/script';
import { APP_IMG, SHOW_COMMEMORATE } from 'src/constants';

const Carousel = dynamic(import('src/components/carousels/carousel-3d'));

const SectionBookcase = ({ bookcase = [], eventDataLayer }) => {
  if (_.isEmpty(bookcase)) return null;

  let slides = [];
  if (!_.isEmpty(bookcase)) {
    slides = bookcase?.map(item => item.value);
    // slides = slides.reverse().filter(el => el !== null);
  }

  return (
    <>
      {!_.isEmpty(slides) && (
        <>
          {/* Flip Image Section bookcase */}
          <Script src='//static.fliphtml5.com/web/js/plugin/LightBox/js/fliphtml5-light-box-api-min.js' strategy='afterInteractive' />
          <div className='container secition-bookcase' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
            <div className='block-wrapper'>
              <div className='block-title'>
                <h2>E-Book กรุงเทพธุรกิจฉบับพิเศษ</h2>
              </div>
            </div>
            <div className='banner-case'>
              <div className='banner-case-img'>
                <Carousel
                  slides={slides}
                  //! DATALAYER
                  eventDataLayer={{
                    ...eventDataLayer,
                    data: {
                      heading: 'E-Book กรุงเทพธุรกิจฉบับพิเศษ'
                    }
                  }}
                />
              </div>
              <div className='banner-case-bg'>
                <img src={`${APP_IMG}/static/bookcase/bg-desktop.png`} alt='bookcase-desktop' width='100%' height='100%' className='bg-desktop' />
                <img src={`${APP_IMG}/static/bookcase/bg-mobile.png`} alt='bookcase-desktop' width='100%' height='100%' className='bg-mobile' />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SectionBookcase;
